import React from "react";

export default function BitacoraHeader({ filtroFecha, onFechaChange, onNuevo, canCreate }) {
  return (
    <div className="management-card management-header mb-4">
      <div>
        <p className="management-eyebrow mb-1">Recepcionista</p>
        <h4 className="management-title mb-0">Bitacora operativa</h4>
        <small className="text-muted">Control diario de visitas y novedades</small>
      </div>

      <div className="d-flex flex-wrap align-items-end gap-3">
        <div className="dashboard-filter">
          <label className="form-label dashboard-label">Filtrar por fecha</label>
          <input
            type="date"
            className="form-control dashboard-input-date"
            value={filtroFecha}
            onChange={(e) => onFechaChange(e.target.value)}
          />
        </div>
        {canCreate && (
          <button className="btn management-btn-primary" onClick={onNuevo}>
            <i className="bi bi-plus-circle me-2" />
            Nuevo registro
          </button>
        )}
      </div>
    </div>
  );
}
